import { useEffect, useState } from 'react';
import styles from '@/page/admin/growth/dashboard_sample/GrowthDashboard.module.css';
import { GrowthDashboardTopCardInfo } from '@/api/growth/dashboard/type';

interface GrowthDashboardHeaderProps {
    topCardInfo?: GrowthDashboardTopCardInfo | null;
}

const GrowthDashboardHeader = ({ topCardInfo }: GrowthDashboardHeaderProps) => {
    const [cardInfo, setCardInfo] = useState(topCardInfo);

    useEffect(() => {
        setCardInfo(topCardInfo);
    }, [topCardInfo]);

    return (
        <>
            <div className="card custom-card profile-card overflow-hidden ">
                <div
                    className={`${styles['candidate-bg-shape']} primary`}
                    style={{
                        background:
                            'url(https://i.pinimg.com/1200x/ff/a6/00/ffa600dc0597481a91dd640710ec9ed3.jpg)',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                    }}
                ></div>
                <div className="card-body pt-5">
                    <div className="d-flex gap-2 flex-wrap mb-1 mt-5">
                        <div className="flex-fill mt-5">
                            <h6 className="mb-1 fw-semibold">
                                <a href="javascript:void(0);">
                                    {cardInfo?.farmlandName || '-'}
                                    <i
                                        className="ri-check-line text-success fs-16"
                                        data-bs-toggle="tooltip"
                                        aria-label="Verified candidate"
                                        data-bs-original-title="Verified candidate"
                                    ></i>
                                </a>
                            </h6>
                            <p className="mb-0 text-muted"></p>
                            <div className="d-flex flex-wrap gap-2 align-items-center fs-12 text-muted">
                                <p className="mb-0">
                                    <i className="ri-map-line me-1 text-muted"></i>{' '}
                                    <span className="fw-medium">
                                        면적 :{' '}
                                        {cardInfo?.area
                                            ? `${cardInfo.area.toLocaleString()} m² / ${(cardInfo.area * 0.3025).toFixed(2)} 평`
                                            : '-'}
                                    </span>
                                </p>
                            </div>
                            <div className="d-flex flex-wrap gap-2 align-items-center fs-12 text-muted">
                                <p className="mb-0">
                                    <i className="ri-map-pin-line me-1 text-muted"></i>{' '}
                                    <span className="fw-medium">
                                        {cardInfo?.address || '-'}
                                    </span>
                                </p>
                            </div>

                            <div className="d-flex fs-14 mt-3 gap-2 flex-wrap">
                                <div className="me-3">
                                    <p className="mb-1 d-flex align-items-center">
                                        <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                            <i className="ri-leaf-fill align-middle fs-15"></i>
                                        </span>
                                        <span className="">
                                            상태 :{' '}
                                            <span className="text-muted fw-normal">
                                                <div
                                                    className={`badge ${cardInfo?.isValid === '1' ? 'bg-success' : 'bg-secondary'}`}
                                                >
                                                    {cardInfo?.isValid === '1'
                                                        ? '진행중'
                                                        : '종료'}
                                                </div>
                                            </span>
                                        </span>
                                    </p>
                                    <p className="mb-1 d-flex align-items-center">
                                        <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                            <i className="ri-calendar-line align-middle fs-15"></i>
                                        </span>
                                        <span className="">
                                            작기 :{' '}
                                            <span className=" fw-normal">
                                                {cardInfo?.startDt || '-'}~
                                                {cardInfo?.endDt || '-'}
                                            </span>
                                        </span>
                                    </p>
                                    <p className="mb-1 d-flex align-items-center">
                                        <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                            <i className="ri-scales-2-line align-middle fs-15"></i>
                                        </span>
                                        <span className="">
                                            현재예상수확량 :{' '}
                                            <span className=" fw-normal">
                                                {cardInfo?.yieldWeight
                                                    ? cardInfo.yieldWeight.toLocaleString()
                                                    : '-'}{' '}
                                                kg/ha
                                            </span>
                                        </span>
                                    </p>
                                </div>
                                <div className="me-3">
                                    <p className="mb-1 d-flex align-items-center">
                                        <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                            <i className="ri-shining-2-line align-middle fs-15"></i>
                                        </span>
                                        <span className="">
                                            작물 :{' '}
                                            <span className=" fw-normal">
                                                <img
                                                    className={
                                                        styles['crop-icon']
                                                    }
                                                    src={
                                                        cardInfo?.gcId
                                                            ? `/images/crop/${cardInfo.gcId}.png`
                                                            : '/images/common/logo/logo_short_dark.png'
                                                    }
                                                    alt={
                                                        cardInfo?.gcName ||
                                                        '작물'
                                                    }
                                                />
                                            </span>{' '}
                                            {cardInfo?.gcName || '-'} /{' '}
                                            {cardInfo?.guName || '-'}
                                        </span>
                                    </p>
                                    <p className="mb-1 d-flex align-items-center">
                                        <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                            <i className="ri-refresh-line align-middle fs-15"></i>
                                        </span>
                                        <span className="">
                                            업데이트 :{' '}
                                            <span className=" fw-normal">
                                                {cardInfo?.regDt || '-'}
                                            </span>
                                        </span>
                                    </p>
                                    <p className="mb-1 d-flex align-items-center">
                                        <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                            <i className="ri-scales-2-fill align-middle fs-15"></i>
                                        </span>
                                        <span className="">
                                            최대예상수확량 :{' '}
                                            <span className=" fw-normal">
                                                {cardInfo?.maxYield
                                                    ? cardInfo.maxYield.toLocaleString()
                                                    : '-'}{' '}
                                                kg/ha
                                            </span>
                                        </span>
                                    </p>
                                </div>
                                <div className="me-3">
                                    <p className="mb-1 d-flex align-items-center">
                                        <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                            <i className="ri-seedling-line align-middle fs-15"></i>
                                        </span>
                                        <span className="">
                                            생육단계 :{' '}
                                            {cardInfo?.growthStageName || '-'}
                                        </span>
                                    </p>
                                    <p className="mb-1 d-flex align-items-center">
                                        <span className="avatar avatar-sm avatar-rounded text-success p-1 bg-success-transparent me-2">
                                            <i className="ri-calendar-schedule-line align-middle fs-15"></i>
                                        </span>
                                        <span className="">
                                            예상수확일 : {cardInfo?.hdat || '-'}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div className="fs-11 text-muted">
                                * 입력된 작물, 농작업, 토양데이터 기반으로
                                예측정보는 실제 수확정보와 다를수있음을
                                알립니다.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default GrowthDashboardHeader;
